interface FilterToggleProps {
    label: string;
    className?: string;
}

const FilterToggleKeyword = ({ label, className = "" }: FilterToggleProps) => {

    const filterButtonTopicClasses = `filter-btn-topic leading-5 ${className}`;

    return (
        <div className="filter-toggle">
            <div
                className={filterButtonTopicClasses}
            >
                {label}
            </div>
        </div>
    );
};

export default FilterToggleKeyword;
